import { objectToUrl, urlToObject } from '../utils/url'
import ENV from '../utils/env'

const isServerError = (code = '') => code.toString()[0] === '5'

// NOTE: server check app version and send different data (lol)
// const VERSION = 'APP6.12.3(5)'
const LOCALE = 'en-US'

const schema = {
  UK: 'card.flyxo.co.uk',
  AE: 'card.flyxo.ae',
  US: 'card.flyxo.com',
}

const getDomainNameApiUrl = () => {
  if (ENV.env === 'dev') {
    if (typeof window === 'undefined') {
      return undefined
    }
    if (window.location.search.includes('master2=true')) {
      return 'https://master.api.jetsm.com'
    }
    try {
      const customHost = localStorage.getItem('XO_COMMON_API_HOST')
      if (customHost) {
        if (customHost.endsWith('/')) {
          return customHost.slice(0, -1)
        }
        return customHost
      }
    } catch (e) {
      console.warn('LocalStorage is not available, using default API host') // eslint-disable-line
    }
    return undefined
  }

  const url = document.location.href

  if (url.includes(schema.US)) {
    return undefined
  }

  if (url.includes(schema.UK)) {
    return ENV.apiHostUK
  }

  if (url.includes(schema.AE)) {
    return ENV.apiHostAE
  }

  return undefined
}

export const apiCall = (endpoint, payload = {}, method = 'POST', headers = {}) => {
  const isInternal = endpoint.indexOf('http') !== 0
  const isFormData = payload instanceof window.FormData
  const hostWithLocales = getDomainNameApiUrl() || ENV.apiHost
  let url = isInternal ? `${hostWithLocales}/${endpoint}` : endpoint

  // dont forget about {cache: "no-cache"} in get requests
  const options = {
    method,
    // fetch automatically sets needed headers if FormData is provided in body
    ...(!isFormData && {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        ...headers,
      },
    }),
    credentials: 'include',
  }
  let defaultParams = {
    lang: LOCALE,
    production: ENV.env === 'prod',
    webapp: true,
  }
  if (ENV.env === 'dev') {
    const parsedUrl = urlToObject(window.location.href)
    const { billing_type: billingType = '' } = parsedUrl
    if (billingType === 'prod') {
      defaultParams.production = true
    }
  }

  if (isInternal && !isFormData) {
    // NOTE: patch inner data with env (for payment, mambership endpoints)
    payload = {
      ...defaultParams,
      ...payload,
      ...(payload.data && {
        data: {
          ...payload.data,
          production: ENV.env === 'prod',
        },
      }),
    }
  }

  if (method === 'POST') {
    options.body = !isFormData ? JSON.stringify(payload) : payload
  }
  if (method === 'GET') {
    url += `?${objectToUrl(payload)}`
  }

  // TODO: tests
  // Mocks server responses:
  // 500 http://www.mocky.io/v2/5b3e3cef3000005000abc635
  // url = 'http://www.mocky.io/v2/5b3e3cef3000005000abc635'
  return (
    fetch(url, options)
      // NOTE: if we have a CORS problem, fetch rejected with TypeError
      .catch(error => {
        if (error instanceof TypeError) {
          console.error('Server error', error) // eslint-disable-line
          throw new Error(`Server error: ${error.message}`, { isServerError: true })
        }
        throw error
      })
      .then(response => {
        if (isServerError(response.status)) {
          console.error('Server error API call', response) // eslint-disable-line
          throw new Error(response.statusText, { ...response, isServerError: true })
        }
        return response.json()
      })
      .then(response => {
        if (response.data) {
          return response.data
        }
        if (!response.status) {
          throw new Error(response.messageForClient || response.message, response)
        }
        return response
      })
  )
}
